// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { NetworkServiceWithRelationsSchema } from './NetworkServiceRelationsSchema'
import type { NetworkServiceWithRelations } from './NetworkServiceRelationsSchema'
import { VhostBindingWithRelationsSchema } from './VhostBindingRelationsSchema'
import type { VhostBindingWithRelations } from './VhostBindingRelationsSchema'
import { GatewaySchema } from './GatewaySchema';

/////////////////////////////////////////
// GATEWAY RELATION SCHEMA
/////////////////////////////////////////

export type GatewayRelations = {
  surface: ExternalNetworkWithRelations;
  services: NetworkServiceWithRelations[];
  vhostBindings: VhostBindingWithRelations[];
};

export type GatewayWithRelations = z.infer<typeof GatewaySchema> & GatewayRelations

export const GatewayWithRelationsSchema: z.ZodType<GatewayWithRelations> = GatewaySchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  services: z.lazy(() => NetworkServiceWithRelationsSchema).array(),
  vhostBindings: z.lazy(() => VhostBindingWithRelationsSchema).array(),
}))